var map = {
	"./button/block.json": "./blocks/button/block.json",
	"./city-teaser/block.json": "./blocks/city-teaser/block.json",
	"./content-slider/block.json": "./blocks/content-slider/block.json",
	"./countdown/block.json": "./blocks/countdown/block.json",
	"./cta/block.json": "./blocks/cta/block.json",
	"./event-teaser/block.json": "./blocks/event-teaser/block.json",
	"./example-block/block.json": "./blocks/example-block/block.json",
	"./fact/block.json": "./blocks/fact/block.json",
	"./faq/block.json": "./blocks/faq/block.json",
	"./film-participant-form/block.json": "./blocks/film-participant-form/block.json",
	"./film-stage/block.json": "./blocks/film-stage/block.json",
	"./hero/block.json": "./blocks/hero/block.json",
	"./history/block.json": "./blocks/history/block.json",
	"./home-stage/block.json": "./blocks/home-stage/block.json",
	"./image-slider/block.json": "./blocks/image-slider/block.json",
	"./keyfact/block.json": "./blocks/keyfact/block.json",
	"./location-map/block.json": "./blocks/location-map/block.json",
	"./membership-form/block.json": "./blocks/membership-form/block.json",
	"./milestone/block.json": "./blocks/milestone/block.json",
	"./newsletter-subscribe/block.json": "./blocks/newsletter-subscribe/block.json",
	"./partner-hero/block.json": "./blocks/partner-hero/block.json",
	"./poi-cards/block.json": "./blocks/poi-cards/block.json",
	"./rss-news-teaser/block.json": "./blocks/rss-news-teaser/block.json",
	"./testimonial/block.json": "./blocks/testimonial/block.json",
	"./timeline-item/block.json": "./blocks/timeline-item/block.json",
	"./timeline/block.json": "./blocks/timeline/block.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive block\\.json";